import { Socket } from "./Socket";

/**
 * Hold all Listener to one Channel.
 */
function createSimpleSocket(request) {
	this.listeners = [];
	const self = this;

	/**
	 * Build a function that call a function on all Listeners.
	 */
	function buildForAll(functionName) {
		return function () {
			const self2 = this;
			const self2arguments = arguments;
			self.listeners.forEach(function (listener) {
				if (typeof listener[functionName] === "function") {
					listener[functionName].apply(self2, self2arguments);
				}
			});
		};
	}

	const simpleRequest = {
		channel: request.channel,
		noAuth: request.noAuth,
		onOpenFailed: buildForAll("onOpenFailed"),
		onOpen: buildForAll("onOpen"),
		onError: buildForAll("onError"),
		onClose: buildForAll("onClose"),
		onMessage: buildForAll("onMessage"),
	};
	// Save the first.
	this.listeners.push(request);
	request.requestIsClosed = false;
	const webSocket = Socket.initConnection(simpleRequest);
	return {
		add: function (listener) {
			self.listeners.push(listener);
		},
		isNotClose: function () {
			const isOpen = webSocket && webSocket.isOpen !== false;
			return isOpen && !self.listeners.every(listener => listener.requestIsClosed);
		},
		closeSocketIfNoOpenChannel: function () {
			if (webSocket && !this.isNotClose()) {
				webSocket.close();
			}
		},
	};
}

function initSimpleSocket() {
	if (typeof window.simplesocket !== "object") {
		window.simplesocket = {};
	}
}

function isOpen(request) {
	const s = window.simplesocket[request.channel];
	return typeof s === "object" && s.isNotClose();
}

function addChannel(request) {
	window.simplesocket[request.channel].add(request);
}

function buildNewChannel(request) {
	//@ts-expect-error:  TODO removing 'new' makes the test failing, because 'this' usage in createSimpleSocket
	window.simplesocket[request.channel] = new createSimpleSocket(request);
}

function removeSubscription(request) {
	request.onOpenFailed = function () {};

	request.onOpen = function () {};

	request.onError = function () {};

	request.onClose = function () {};

	request.onMessage = function () {};

	request.requestIsClosed = true;
	window.simplesocket[request.channel].closeSocketIfNoOpenChannel();
}

export const SimpleSocket = {
	initConnection: function (request: any): Record<string, any> {
		initSimpleSocket();

		if (isOpen(request)) {
			addChannel(request);
		} else {
			buildNewChannel(request);
		}

		const channelHandler = {
			close: function () {
				removeSubscription(request);

				channelHandler.close = function () {
					console.warn("SimpleSocket already closed.");
				};
			},
		};
		return channelHandler;
	},
};
